import type { Reference } from "../../../../../models";
import type { CommandBody } from "../CrossOriginMessage";

/**
 * Indicates the object that was selected.
 */
export class ClickCommandBody implements CommandBody {
  /**
   * Selected object reference.
   */
  objectRef: Reference;
}
